<template>
  <Card>
    <template slot="title">
      <Breadcrumb>
        <BreadcrumbItem to="/inv/meta">报表Meta管理</BreadcrumbItem>
        <BreadcrumbItem>新增ShortName</BreadcrumbItem>
      </Breadcrumb>
    </template>
    <router-link to="/inv/meta" slot="extra">返回</router-link>
    <Form
      :model="formItem"
      :label-width="140"
      ref="formValidate"
      :rules="ruleInline"
    >
      <FormItem label="short name" prop="shortName">
        <Input
          v-model="formItem.shortName"
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input
          v-model="formItem.remark"
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="save('formValidate')">保存</Button>
        <Button style="margin-left: 8px" @click="cancel('formValidate')">取消</Button>
      </FormItem>
    </Form>
  </Card>
</template>
<script>

  export default {
    data() {
      return {
        ruleInline: {
          shortName: [
            {required: true, message: '请输入shortName'}
          ],
          remark: [
            {required: false, message: '请输入备注'}
          ],
        },
        formItem: {
          shortName: "",
          remark: "",
        },
        isEdit: false,
      };
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
    },
    methods: {
      save(name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            this.$api.addInvReportShortName(this.formItem).then(res => {
              if (res.code == '200') {
                this.$Message.success("编辑成功");
                this.$router.replace({path: '/inv/meta'});
              } else {
                this.$Message.error(res.message);
              }
            });
          }
        });
      },
      cancel(name) {
        this.$router.back()
      },
    }
  };
</script>
<style scoped>
  .title {
    font-size: 16px;
    font-weight: 700;
    padding-left: 8px;
    color: #333;
    padding: 20px 0;
    margin: 40px 0 0 0;
    border-top: 1px solid #eaecf0;
  }

  .title:first-child {
    border-top: none;
    margin: 0;
  }

  .main-image {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 60px;
    border-radius: 4px;
    background-color: #f8f9fa;
    border: 1px solid #dcdfe6;
    margin-right: 20px;
    margin-top: 10px;
    overflow: hidden;
  }

  .main-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .main-image .delete {
    display: none;
    position: absolute;
    height: 20px;
    text-align: center;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
  }

  .main-image .delete::after {
    content: " ";

    display: inline-block;
    height: 20px;
    width: 14px;
    background-image: url(data:image/png;base64,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);
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .main-image:hover .delete {
    display: block;
  }

  #editor {
    position: relative;
    z-index: 99;
  }
</style>



// WEBPACK FOOTER //
// src/views/invreport/shortNameAdd.vue